import { FC } from 'react';

import { classNames } from '@/utils/classNames';

import { DDPNotitie } from '../../types/ddpTypes';

import NotitieIcon from './NotitieIcon';
import NotitieStatus from './NotitieStatus';

import styles from './Notitie.module.css';

type NotitieRelatedItemProps = {
  notitie?: DDPNotitie;
  inFlow?: boolean;
};
const notitieHeeftZichtbareInhoud = (notitie?: DDPNotitie) => Boolean(notitie?.status) || Boolean(notitie?.opmerking);

const NotitieRelatedItem: FC<NotitieRelatedItemProps> = ({ notitie = undefined, inFlow = false }) => {
  return (
    <>
      {notitieHeeftZichtbareInhoud(notitie) && (
        <div className={classNames(styles.notitieRelatedItemStyle, inFlow && styles.notitieRelatedItemInFlowStyle)}>
          <div className={styles.notitieRelatedItemStatusStyle}>
            {notitie?.status && <NotitieStatus status={notitie.status} />}
          </div>
          <div className={styles.notitieRelatedItemIconStyle}>{notitie?.opmerking !== '' && <NotitieIcon />}</div>
        </div>
      )}
    </>
  );
};
export default NotitieRelatedItem;
